import { Badge } from '@ipfabric/ui-components/Badge/Badge';
import { Link } from '@ipfabric/ui-components/Link/Link';
import type { ServiceStatus } from '@ipfabric/utils/api/systemStatus';
import { RestartService } from 'pages/Support/Status/RestartService';
import type React from 'react';

type Props = {
  label: string;
  status?: ServiceStatus;
  /** Name of the system (currently Debian systemd) service */
  serviceName: string;
  onServiceRestarted: () => void;
};

export const McpServerServiceStatusRow: React.FC<Props> = ({
  label,
  status,
  onServiceRestarted,
  serviceName,
}) => {
  return (
    <div className='flex flex-row gap items-center px py-2xs border-b border-divider'>
      <div className='flex-1 font-semibold'>{label}</div>
      {status ? (
        status.isEnabled ? (
          <>
            <div>
              <Badge
                color={status.isRunning ? 'success' : 'error'}
                icon={status.isRunning ? 'fa-check-circle' : 'fa-circle-xmark'}
              >
                {status.isRunning ? 'Running' : 'Not running'}
              </Badge>
            </div>
            <RestartService
              serviceName={serviceName}
              onServiceRestarted={onServiceRestarted}
            />
          </>
        ) : (
          <>
            <div>
              <Badge color='warning' icon='fa-circle-info'>
                Disabled
              </Badge>
            </div>
            <Link
              renderAs='link'
              size='small'
              to='/settings/integration/mcp-server'
            >
              Configure
            </Link>
          </>
        )
      ) : null}
    </div>
  );
};
